import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromAdmin from './admin.reducer';

export const selectAdminState = createFeatureSelector<fromAdmin.AdminState>(fromAdmin.adminFeatureKey);

export const selectAdmin = createSelector(
  selectAdminState,
  (state: fromAdmin.AdminState) => state.admin
);
